export default __webpack_public_path__ + "static/media/avatar-s-10.6eef1c6c.jpg";